import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './EmailStep.css';
import React, { useState } from 'react';
import { ReactComponent as EmailLargeIcon } from "../../resources/icons/email-large.svg";
import { TextInputWithValidation } from '../atoms/TextInputWithValidation/TextInputWithValidation';
import BlackCheckbox from '../atoms/BlackCheckbox/BlackCheckbox';
var EmailStep = function EmailStep(_ref) {
  var rtl = _ref.rtl,
    title = _ref.title,
    description = _ref.description,
    emailRecomendationText = _ref.emailRecomendationText,
    emailAddressLabel = _ref.emailAddressLabel,
    emailSubscriptionLabel = _ref.emailSubscriptionLabel,
    privacyNoticeContent = _ref.privacyNoticeContent,
    patternInvalidMessage = _ref.patternInvalidMessage,
    initData = _ref.initData,
    onDataChange = _ref.onDataChange,
    onReceiveOffersCheck = _ref.onReceiveOffersCheck;
  var _useState = useState(initData.receiveOffers),
    _useState2 = _slicedToArray(_useState, 2),
    receiveOffers = _useState2[0],
    setReceiveOffers = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "email-step__title-descr-wrapper"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "email-step__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "email-step__description"
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: "email-step__email-recommendations-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "email-step__email-recommendations"
  }, /*#__PURE__*/React.createElement(EmailLargeIcon, {
    className: "email-step__email-icon"
  }), emailRecomendationText)), /*#__PURE__*/React.createElement("div", {
    className: "email-step__form-wrapper"
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, emailAddressLabel), /*#__PURE__*/React.createElement("label", null, emailAddressLabel), /*#__PURE__*/React.createElement(TextInputWithValidation, {
    pattern: ".+@.+\\..+",
    value: initData.email,
    patternInvalidMessage: patternInvalidMessage,
    onChange: function onChange(e) {
      onDataChange({
        receiveOffers: e.currentTarget.value ? receiveOffers : false,
        isValid: !e.currentTarget.validity.patternMismatch,
        email: e.currentTarget.value
      });
    },
    type: "email"
  })), /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(BlackCheckbox, {
    id: "emailSubscription",
    onChange: function onChange(checked) {
      onReceiveOffersCheck && onReceiveOffersCheck(checked);
      setReceiveOffers(checked);
      onDataChange(_objectSpread(_objectSpread({}, initData), {}, {
        receiveOffers: initData.email ? checked : false
      }));
    },
    checked: receiveOffers,
    label: emailSubscriptionLabel
  })), /*#__PURE__*/React.createElement("div", {
    className: "email-step__policy",
    dangerouslySetInnerHTML: {
      __html: privacyNoticeContent
    }
  })));
};
export default EmailStep;
var commonStyles = "c6unc86";
var ltrStyles = "lkiafa6";
var rtlStyles = "rtg0k7q";